import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Divider, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

const BreakingLease = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div>
      <div className="list-container">
        <Alert
          message={
            <div style={{ textDecorationLine: "underline" }}>
              Send this email to the tenant in appfolio- put the address in the
              subject line
            </div>
          }
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />
        <Alert
          message="We have received your notice to vacate but have found that your lease is not yet up per your contract.  Per our policies you have 2 basic options to close out your lease."
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />

        <Alert
          message="1. Complete your full lease until the final date listed on the agreement.  In this situation you would continue to pay all rent and fees and maintain the property and utilities until the final day of your lease."
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />

        <Alert
          message="2. Pay the lease break fees as follows:"
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />

        <Alert
          message="-pay rent in full until your agreed on move out date"
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />

        <Alert
          message="-pay a fee of 1 and 1/2 months rent (eg - rent $1000 so fee would be $1500)"
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />
        <Alert
          message="-forfeit your security deposit in full in addition to paying the lease break fee."
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />
        <Alert
          message="-leave the home in move in ready condition (any damages left would be billed to you and payment required or it would be sent on to our collections agency.)"
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />
        <Alert
          message="Please reply back to this message and let me know how you would like to proceed."
          type="success"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        />
        <Alert
          message="If the tenant elects to break the lease"
          type="info"
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            textAlign: "center",
            color: "#e15951",
          }}
        />
        <Alert
          message="-Enter a charge of 1 and 1/2 months rent on their ledger (now) "
          type="info"
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            textAlign: "center",
            color: "#e15951",
          }}
        />
        <Alert
          message="-Enter a charge equal to their security deposit on their ledger. (after they move out)"
          type="info"
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            textAlign: "center",
            color: "#e15951",
          }}
        />

        <Row justify="end" gutter={16}>
          <Col>
            <Button>Skip</Button>
          </Col>
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              onClick={handleComplete}
              disabled={isDisabled}
            >
              Complete
            </Button>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={2}>
            <Avatar>KA</Avatar>
          </Col>
          <Col span={22}>
            <TextArea
              style={{
                height: 200,
                resize: "none",
              }}
              placeholder="Write a comment… Type @ to mention other users."
            />
          </Col>
        </Row>
        <Row justify="end" gutter={16}>
          <Col>
            <Upload>
              <Button style={{ marginTop: "10px" }}>
                <UploadOutlined />
              </Button>
            </Upload>
          </Col>
          <Col>
            <Button style={{ marginTop: "10px" }}>Send</Button>
          </Col>{" "}
        </Row>
      </div>
    </div>
  );
};

export default BreakingLease;
